<template>
  <section class="content">
    <div class="callout callout-info">
      <h4>Analysis</h4>
    </div>

    <!--chart-->
    <div class="row">
      <analysis-chart
        type="monthly"
        path="connectionanalysis"
        title="Device Connection Counts (Last Year)"
      />
      <analysis-chart
        type="deviceid"
        path="deviceconnectcountsanalysis"
        title="Device Connection Counts"
      />
      <analysis-chart
        type="daily"
        path="dailyactivationanalysis"
        title="Device Daily Activation Counts (Last 30 Days)"
      />
      <analysis-chart
        type="monthly"
        path="monthlyactivationanalysis"
        title="Device Monthly Activation Counts (Last Year)"
      />
      <analysis-chart
        type="duration"
        path="disconnectdurationanalysis"
        title="Device Disconnect Durations"
      />
    </div>
    <!--chart-->
  </section>
</template>
<script>
import AnalysisChart from "../modules/AnalysisChart.vue";

export default {
  name: "Analysis",
  components: {
    AnalysisChart
  }
};
</script>


<style>
</style>



// WEBPACK FOOTER //
// ConnectionAnalysis.vue?5ccb2e94